import Vue from 'vue';
import store from '../common/js/vuex/store';
import personalLoanCalculator2021 from './personal-loan-calculator-2021/personal-loan-calculator-2021.vue';
import personalLoanCalculator2021Button from './personal-loan-calculator-2021/personal-loan-calculator-2021-button/personal-loan-calculator-2021-button.vue';
import personalLoanCalculator2021Store from '../applications/personal-loan-calculator-2021/personal-loan-calculator-2021-vuex';
if (!store.hasModule(['personalLoanCalculator2021'])) {
	store.registerModule('personalLoanCalculator2021', personalLoanCalculator2021Store);
}
Vue.component('personal-loan-calculator-2021', personalLoanCalculator2021);
Vue.component('personal-loan-calculator-2021-button', personalLoanCalculator2021Button);
